import types from '../constants';

const initialState = {
  playlists: {
    meta: {
      status: 'loading'
    },
    data: []
  },
  programmeGuides: {
    meta: {
      status: 'loading'
    },
    data: []
  }
};

export default function channels(state = initialState, action) {
  switch (action.type) {
  case types.GET_CHANNELS_PLAYLIST_LOADING:
    return {
      ...state,
      playlists: { ...state.playlists, meta: { status: 'loading' } }
    };
  case types.GET_CHANNELS_PLAYLIST_SUCCESS:
    return { ...state, playlists: { ...state.playlists, ...action.payload } };
  case types.GET_CHANNELS_PLAYLIST_ERROR:
    return {
      ...state,
      playlists: {
        ...state.playlists,
        meta: { status: 'error', error: 'something went wrong!' }
      }
    };
  case types.GET_PROGRAMME_GUIDES_LOADING:
    return {
      ...state,
      programmeGuides: {
        ...state.programmeGuides,
        meta: { status: 'loading' }
      }
    };
  case types.GET_PROGRAMME_GUIDES_SUCCESS:
    return {
      ...state,
      programmeGuides: { ...state.programmeGuides, ...action.payload }
    };
  case types.GET_PROGRAMME_GUIDES_ERROR:
    return {
      ...state,
      programmeGuides: {
        ...state.programmeGuides,
        meta: { status: 'error', error: 'something went wrong!' }
      }
    };
  case types.UI_RE_RENDER_SCHEDULE:
    return {
      ...state
    };
  default:
    return {
      ...initialState,
      ...state
    };
  }
}
